module.exports = __webpack_public_path__ + "img/offers4.ced5ee8c.webp";